import React from 'react';
import {NavLink} from 'react-router-dom';
import { useLocale } from '../../localization/LocaleContext';
import './sidedrawer.css';


const SideDrawer = props => {
    const { t, toLocalizedPath } = useLocale();
    let drawerClasses = ['side-drawer']
    if(props.show){
        drawerClasses = ['side-drawer open']
    }
    // console.log(props)

    return(
        <nav className={drawerClasses} onClick={props.drawerClickHandler}>
            <ul>
                <li>
                    <img src={`${process.env.PUBLIC_URL}/images/main-logo.svg`} alt="Invoice Point logo" />
                </li>
                <li>
                    <NavLink exact={true} activeStyle={{color:"#27c492"}} to={toLocalizedPath('home')}>
                        {t('nav.home')}
                    </NavLink>
                </li>

                <li className="side-drawer-group-label">{t('nav.features')}</li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('aiEstimator')}>
                        {t('nav.aiEstimator')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('invoicing')}>
                        {t('nav.invoicing')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('quotes')}>
                        {t('nav.quotes')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('timeTracking')}>
                        {t('nav.timeTracking.heading')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('payments')}>
                        {t('nav.payments')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('paymentReminders')}>
                        {t('nav.paymentReminders')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('clients')}>
                        {t('nav.clients')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('expenses')}>
                        {t('nav.expenses')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('reports')}>
                        {t('nav.reports')}
                    </NavLink>
                </li>

                <li className="side-drawer-group-label">{t('nav.solutions')}</li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('freelancers')}>
                        {t('nav.freelancers')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('smallBusiness')}>
                        {t('nav.smallBusiness')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('organization')}>
                        {t('nav.organization')}
                    </NavLink>
                </li>

                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('pricing')}>
                        {t('nav.pricing')}
                    </NavLink>
                </li>

                <li className="side-drawer-group-label">{t('nav.resources')}</li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('howItWorks')}>
                        {t('nav.howItWorks')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('helpCenter')}>
                        {t('nav.helpCenter')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('templates')}>
                        {t('nav.templates')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('guides')}>
                        {t('nav.guides')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('blog')}>
                        {t('nav.blog')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('contact')}>
                        {t('nav.contact')}
                    </NavLink>
                </li>

                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('faqs')}>
                        {t('nav.faqs')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('termsOfService')}>
                        {t('nav.terms')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('privacyPolicy')}>
                        {t('nav.privacy')}
                    </NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default SideDrawer;